import { useRef } from 'react';
import type { TaskState } from '../../api/rmf-client';
import { useTaskTypeText } from './use-task-type-text';

/** One live row's Type cell -- see `useTaskTypeText`. */
export function TaskTypeCell({ task }: { task: TaskState }) {
  const ref = useRef<HTMLSpanElement>(null);
  return <span ref={ref}>{useTaskTypeText(task, ref)}</span>;
}
